import { render, staticRenderFns } from "./PasswordSet.vue?vue&type=template&id=4f076233&scoped=true"
import script from "./PasswordSet.vue?vue&type=script&lang=js"
export * from "./PasswordSet.vue?vue&type=script&lang=js"
import style0 from "./PasswordSet.vue?vue&type=style&index=0&id=4f076233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f076233",
  null
  
)

export default component.exports